import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_REASON_SURGE, GET_REASON_SURGE_SUCCESS, GET_REASON_SURGE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getReasonSurge({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-remarks-cancellation`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_REASON_SURGE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_REASON_SURGE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_REASON_SURGE_ERROR, payload: error });
  }
}

export function* watchgetReasonSurge() {
  yield takeEvery(GET_REASON_SURGE, getReasonSurge);
}

function* getReasonSurgeSaga() {
  yield all([fork(watchgetReasonSurge)]);
}

export default getReasonSurgeSaga;
